import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { X, Plus, Loader2 } from "lucide-react";

interface FilterBadgeListProps {
  items: string[];
  onRemove: (item: string) => void;
  onFindSimilar: () => void;
  disabled?: boolean;
  isPending?: boolean;
}

export function FilterBadgeList({
  items,
  onRemove,
  onFindSimilar,
  disabled,
  isPending = false,
}: FilterBadgeListProps) {
  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {items.map((item, index) => (
        <Badge
          key={`${item}-${index}`}
          variant="secondary"
          className="flex items-center gap-1"
        >
          {item}
          <X
            className="h-3 w-3 cursor-pointer"
            onClick={() => onRemove(item)}
          />
        </Badge>
      ))}

      <Button
        type="button"
        variant="outline"
        size="sm"
        className="text-teal-600 border-teal-200 bg-transparent hover:bg-teal-50"
        onClick={onFindSimilar}
        disabled={disabled || isPending || items.length === 0}
      >
        {isPending ? (
          <Loader2 className="h-3 w-3 mr-1 animate-spin" />
        ) : (
          <Plus className="h-3 w-3 mr-1" />
        )}
        {isPending ? "Finding..." : "Find Similar"}
      </Button>
    </div>
  );
}
